import { useState } from 'react';
import { Box, Grid2, Typography } from '@mui/material';
import CustomDivider from '../../shared/utils/CustomDivider';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import { useAdminApartmentList, useCourseList, useOrderList } from '../../assets/api/useAdminApi';
import CreateOrderForm from './CreateOrderForm';
import { Field } from 'formik'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import CustomSlider from '../../shared/components/formfields/CustomSlider'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { formatDateToDDMMYYYY } from '../../shared/formatter';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';

const OrderList = () => {
    const [filters, setFilters] = useState({});
    const { data: orderList, isLoading } = useOrderList(filters);
    const { data: apartmentlist, isLoading: apartmentLoading } = useAdminApartmentList()
    const apartmentOption = apartmentlist?.data?.map((item, index) => ({
        id: index + 1,
        label: item?.apartment_name,
        value: item?.apartment_name,
    }))
    const paymentStatusOption = [
        {
            id: 1,
            label: "Paid",
            value: "Paid",
        },
        {
            id: 0,
            label: "Pending",
            value: "Pending",
        }
    ]

    const { data: courseList, isLoading: isCourseLoading } = useCourseList();
    const CoursesOptions = courseList?.data
        ?.filter(course => course?.status == 1)
        ?.map(course => ({
            id: course?.id,
            label: course?.title,
            value: course?.title,
        })) || [];
    const getFilteredValuesWithprice = (values) => {
        const { price, ...rest } = values;

        const baseFiltered = Object.fromEntries(
            Object.entries(rest).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
        );

        if (Array.isArray(price) && price.length === 2) {
            return {
                ...baseFiltered,
                min_price: price[0],
                max_price: price[1],
            };
        }

        return baseFiltered;
    };
    const orderColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            width: 50,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "firstname",
            headerName: "Parent Name",
            width: 100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "lastname",
            headerName: "Student Name",
            width: 100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "event_title",
            headerName: "Course Name",
            width: 200,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            width: 200,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "price",
            headerName: "Price",
            width: 100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "quantity",
            headerName: "Quantity",
            width: 100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "total_price",
            headerName: "Total Price",
            width: 100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "payment_status",
            headerName: "Payment Status",
            width: 200,
            renderCell: (params) => <>{params.value === 1 ? <Typography variant="body2" color='success.main'>Payment Successful</Typography> : <Typography variant="body2" color='yellow.main'>Payment pending</Typography>}</>,
        },
        {
            field: "status",
            headerName: "Order Status",
            width: 200,
            renderCell: (params) => <Typography variant="body2">{params.value === 1 ? <Typography variant="body2" color='success.main'>Payment Authorized</Typography> : <Typography variant="body2" color='yellow.main'>Order created</Typography>}</Typography>,
        },
        {
            field: "payment_order_id",
            headerName: "Payment Order Id",
            width: 200,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "payment_method",
            headerName: "Payment Method",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "created_at",
            headerName: "Order Date",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{formatDateToDDMMYYYY(params.value)}</Typography>,
        },


    ];
    return (
        <Box>
            <CustomDivider />
            <NormalContainerWithHeader headerText={"Create Order"}>
                <CreateOrderForm />
            </NormalContainerWithHeader>
            <CustomDivider />
            <TableFilterTemplate
                title="Order List"
                columns={orderColumns}
                rowsData={orderList?.data || []}
                dataGridProps={{ getRowId: (row) => `${row.id}_${row.sr_no}` }}
                isLoading={isLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                filterTransformer={getFilteredValuesWithprice}
                renderFilterFields={() => (
                    <>
                        <Grid2 children size={12}>
                            <Field
                                name="apartment_name"
                                component={AutoCompleteField}
                                options={apartmentOption}
                                isLoading={apartmentLoading}
                                label="Apartment Name"
                                isRequired={true}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="course_id"
                                component={IdAutoCompleteField}
                                options={CoursesOptions}
                                label="Course Name"
                                isLoading={isCourseLoading}
                                isRequired={true}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="payment_status"
                                component={IdAutoCompleteField}
                                options={paymentStatusOption}
                                label="Payment Status"
                                isRequired={true}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="price"
                                component={CustomSlider}
                                label="price"
                                initialValue={0}
                                finalValue={5000}
                            />
                        </Grid2>
                    </>
                )}
            />
        </Box>
    );
};

export default OrderList;
